import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppConfig } from '@config/app.config';
import { GeneralsService } from '@core/services/generals.service';
import { RulesService } from '@core/services/rules.service';
import { Constants } from '@shared/class/constants.class';
import { Rule } from '@shared/interfaces/rule';

@Component({
  selector: 'app-rules-edit',
  templateUrl: './rules-edit.component.html'
})
export class RulesEditComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public rule: Rule;
  public rulesList: Array<Rule> = [];
  public ruleForm: FormGroup;

  constructor(
    public appConfig: AppConfig,
    private generalsService: GeneralsService,
    private rulesService: RulesService,
    public dialogRef: MatDialogRef<RulesEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit() {
    this.constants.title = this.appConfig.LANG.rules.title;

    this.ruleForm = new FormGroup({
      id: new FormControl('', Validators.required),
      name: new FormControl('', Validators.required)
    });

    this.constants.action = this.data.action;

    if (this.constants.action === this.appConfig.ACTIONS.edit.id) {
      this.constants.title =
        this.appConfig.LANG.title.edit + ' ' + this.constants.title;
      this.rule = this.data.item;
      this.ruleForm.patchValue({
        id: this.rule.id,
        name: this.rule.name
      });
    } else if (this.constants.action === this.appConfig.ACTIONS.add.id) {
      this.constants.title =
        this.appConfig.LANG.title.add + ' ' + this.constants.title;
    }
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  onSubmit() {
    const form = this.ruleForm;
    if (form.dirty && form.valid) {
      this.generalsService.save(
        this.constants.action,
        form,
        this.dialogRef,
        this.rulesService
      );
    } else {
      this.close();
    }
  }

  close() {
    this.dialogRef.close(300);
  }
}
